@if (loading) {
<div class="lb-wrap lb-wrap--skeleton">
  <div class="lb-header">
    <div class="lb-header__left">
      <div class="lb-sk__logo sk-bone"></div>
      <div class="lb-sk__name-col">
        <div class="lb-sk__line lb-sk__line--sm sk-bone"></div>
        <div class="lb-sk__line lb-sk__line--lg sk-bone"></div>
      </div>
    </div>
    <div class="lb-sk__badge sk-bone"></div>
  </div>
  <div class="lb-sk__pct sk-bone"></div>
</div>
} @else {
<div class="lb-wrap" [style.--sc]="statusColor">

  <!-- ── Brillo decorativo superior derecha ── -->
  <div class="lb-glow lb-glow--tr"
       [style.background]="'radial-gradient(circle,' + statusColor + '18 0%, transparent 70%)'">
  </div>
  <div class="lb-glow lb-glow--bl"></div>

  <!-- ── Header: logo + nombre + badge En vivo ── -->
  <div class="lb-header">
    <div class="lb-header__left">

      <div class="lb-logo">
        @if (imageUrl && !imgError) {
          <img class="lb-img" [src]="imageUrl" (error)="onImgError()" alt="logo" />
        } @else {
          <span class="lb-placeholder"><i class="pi pi-image"></i></span>
        }
      </div>

      <div class="lb-name-col">
        <div class="lb-name-row">
          <span class="lb-dot" [style.background]="statusColor"
                [style.box-shadow]="'0 0 6px ' + statusColor + '99'"></span>
          <span class="lb-tag">{{ subtitle || 'SDV' }}</span>
        </div>
        @if (title) {
          <h2 class="lb-title">{{ title }}</h2>
        }
      </div>
    </div>

    @if (badge) {
      <span class="lb-live">
        <span class="lb-live__dot"></span>
        {{ badge }}
      </span>
    }
  </div>

  <!-- ── Body: % grande + estado ── -->
  @if (compliancePercent !== null) {
    <div class="lb-body">
      <div class="lb-metric">
        <span class="lb-pct">{{ compliancePercent | number:'1.0-1' }}%</span>
        <span class="lb-pct-label">cumplimiento</span>
      </div>
      <div class="lb-meta">
        @if (statusLabel) {
          <span class="lb-state-pill"
                [style.color]="statusColor"
                [style.border-color]="statusColor + '55'"
                [style.background]="statusColor + '18'">
            {{ statusLabel }}
          </span>
        }
      </div>
    </div>
  }


</div>
}
